// -----------------------------------------------------------
// FloraIQ - EmptyState Unificado
// -----------------------------------------------------------

export interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export default function EmptyState({ icon = "ri-inbox-line", title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mb-4">
        <i className={`${icon} text-2xl text-foreground-400`}></i>
      </div>
      <h3 className="text-lg font-semibold text-foreground-800 font-heading mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-foreground-500 max-w-sm">{description}</p>
      )}
      {action && (
        <button onClick={action.onClick} className="btn-primary mt-4 text-sm cursor-pointer">
          <i className="ri-add-line"></i>
          {action.label}
        </button>
      )}
    </div>
  );
}